import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-ivory grain">
      <header className="border-b border-[#0E1A2B]/10 bg-ivory sticky top-0 z-40">
        <div className="h-[2px] bg-gold w-full" />
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-3" data-testid="brand-link">
            <img src="/brand/logo.png" alt="Goldline Advisory" className="w-11 h-11 object-contain" />
            <div>
              <div className="font-display text-navy text-base font-semibold leading-none">Goldline Advisory</div>
              <div className="eyebrow text-navy/50 mt-1">Goldline Clarity System · Assessments · Automation · Sprints</div>
            </div>
          </Link>
          {user && (
            <div className="flex items-center gap-4">
              <Link to="/dashboard" className="text-sm text-navy/60 hover:text-gold hidden md:inline" data-testid="nav-intakes">Intakes</Link>
              <Link to="/leads" className="text-sm text-navy/60 hover:text-gold hidden md:inline" data-testid="nav-leads">Leads</Link>
              <Link to="/snapshots" className="text-sm text-navy/60 hover:text-gold hidden md:inline" data-testid="nav-snapshots">Snapshots</Link>
              <Link to="/catalog" className="text-sm text-navy/60 hover:text-gold hidden md:inline" data-testid="nav-catalog">Tool Catalog</Link>
              <div className="text-right hidden md:block">
                <div className="text-sm font-medium text-navy">{user.name}</div>
                <div className="text-xs text-navy/50">{user.email}</div>
              </div>
              <Button variant="ghost" size="sm" onClick={() => { logout(); nav("/login"); }} data-testid="logout-btn">
                <LogOut className="w-4 h-4 mr-1" /> Sign out
              </Button>
            </div>
          )}
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
